// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"228":"404notfound","309":"termsandconditions","609":"faq","987":"privacypolicy"}[chunkId] + "." + {"228":"032e00fb","309":"dcc92aa4","609":"23422665","987":"04017023"}[chunkId] + ".css";
};